module.exports = {
      id: "vikatan-play-usage",
      viewBox: "0 0 27.8 28.8",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#vikatan-play",
      toString: function () {
        return this.url;
      }
    }